import Ayuda from "../../../containers/ayuda"

export const Help = ()=>{
    return <Ayuda/>
}